// Re-match spec-validity gate (ClickUp 86d3dxnd7).
//
// The /intake/re-match endpoint HARD-validates the spec via
// CSC_CORE/Features/QuotationIntake/Validators/RematchLineItemRequestDtoValidator.cs
// (diameter > 0, length > 0, grade ∈ {33,40,60,75,80}). The client must gate the
// auto/manual re-match on the SAME rules — gating only on "non-null" lets an invalid
// spec (notably a non-canonical extracted grade) through, firing a request that 400s
// and dumps the raw validation string into a toast on a line the user sees as not-ready.
//
// Keep REMATCH_ALLOWED_GRADES in lock-step with the validator's AllowedGrades.

const REMATCH_ALLOWED_GRADES = new Set([33, 40, 60, 75, 80]);

/** Friendly pre-flight guidance — shown BEFORE the network call (disabled-button
 *  tooltip + rematchSingle pre-flight toast), never from the failure catch. */
export const REMATCH_INVALID_SPEC_MESSAGE =
  'Set a valid grade (G33/40/60/75/80), diameter and length to re-match.';

/** True when the line's spec satisfies the server re-match validator, so a
 *  re-match request will not 400. Mirrors RematchLineItemRequestDtoValidator. */
export function isSpecValidForRematch(item: {
  diameterMm?: number | null;
  lengthM?: number | null;
  gradeCode?: string | null;
}): boolean {
  return (
    item.diameterMm != null &&
    item.diameterMm > 0 &&
    item.lengthM != null &&
    item.lengthM > 0 &&
    item.gradeCode != null &&
    REMATCH_ALLOWED_GRADES.has(Number(item.gradeCode))
  );
}
